<!-- Button trigger modal -->
<div style="text-align: right">
    </div>
    <!-- Modal -->
    <div class="modal fade" id="removeBranchModal" tabindex="-1" role="dialog" aria-labelledby="removeBranchModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="removeBranchModalLabel">Remover Sucursal</h5>
                <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div *ngIf="branchData" class="modal-body">
                <p>Está seleccionando remover la sucursal <strong>{{ branchData.name }}</strong></p>
                <p>Para confirmar esto, seleccione remover nuevamente.</p>
            </div>
            <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
                Error intente luego...
            </div>
            <div class="modal-footer">
            
                <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                <button type="button" (click)="removeBranch()" class="btn btn-danger">Remover</button>
            </div>
       
        </div>
    </div>
    </div>